export default "__VITE_ASSET__50d2633e__"